/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function r(r){return"string"==typeof r||Array.isArray(r)}export{r as isVariantLabel};
//# sourceMappingURL=is-variant-label.js.map
